package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.FavoriteW500RoundedFill: ImageVector
    get() {
        if (_favoriteW500RoundedFill != null) {
            return _favoriteW500RoundedFill!!
        }
        _favoriteW500RoundedFill = Builder(name = "FavoriteW500RoundedFill", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(447.32f, 814.34f)
                quadToRelative(-16.3f, -5.84f, -28.97f, -18.27f)
                lineToRelative(-69.48f, -63.48f)
                quadTo(243.35f, 636.3f, 157.61f, 539.97f)
                quadTo(71.87f, 443.63f, 71.87f, 326.0f)
                quadToRelative(0.0f, -97.59f, 65.15f, -162.98f)
                quadToRelative(65.15f, -65.39f, 162.74f, -65.39f)
                quadToRelative(52.52f, 0.0f, 99.28f, 21.42f)
                quadToRelative(46.76f, 21.43f, 80.72f, 59.47f)
                quadToRelative(33.96f, -38.04f, 80.72f, -59.47f)
                quadToRelative(46.76f, -21.42f, 99.28f, -21.42f)
                quadToRelative(97.59f, 0.0f, 163.1f, 65.39f)
                quadToRelative(65.51f, 65.39f, 65.51f, 162.98f)
                quadToRelative(0.0f, 117.63f, -85.6f, 214.47f)
                quadToRelative(-85.6f, 96.83f, -193.12f, 193.36f)
                lineToRelative(-68.24f, 62.47f)
                quadToRelative(-12.67f, 12.44f, -29.08f, 18.16f)
                quadToRelative(-16.42f, 5.71f, -32.57f, 5.71f)
                reflectiveQuadToRelative(-32.44f, -5.83f)
                close()
            }
        }
        .build()
        return _favoriteW500RoundedFill!!
    }

private var _favoriteW500RoundedFill: ImageVector? = null
